export default __webpack_public_path__ + "static/media/logo.b8c501f1.png";